<template>
  <div class="kpt-feedback-context-pane">
    <header class="kpt-context-pane-header">
      <h4><strong>Send Us Feedback</strong></h4>
      <b-icon class="has-cursor-pointer" icon="times-circle" @click.native="close"></b-icon>
    </header>
    <main class="kpt-context-pane-main">
      <p>Thank you for taking the time to submit your feedback.</p>
      <hr>
      <b-field label="Are you satisfied with the Kymeta Access portal?">
        <div class="kpt-feedback-icons">
          <span class="feedback-icon kpt-smile-icon" :class="{ 'has-text-success': mood == 'happy' }" @click="mood = 'happy'"><font-awesome-icon :icon="['far', 'smile-beam']" size="2x" /></span>
          <span class="feedback-icon kpt-meh-icon" :class="{ 'has-text-warning': mood == 'meh' }" @click="mood = 'meh'"><font-awesome-icon :icon="['far', 'meh']" size="2x" /></span>
          <span class="feedback-icon kpt-frown-icon" :class="{ 'has-text-danger': mood == 'sad' }" @click="mood = 'sad'"><font-awesome-icon :icon="['far', 'frown']" size="2x" /></span>
        </div>
      </b-field>
      <b-field label="Tell us about your experience:">
        <b-input :disabled="submitting" type="textarea" maxlength="999" custom-class="no-resize" rows="10" v-model="feedback"></b-input>
      </b-field>
    </main>
    <footer class="kpt-context-pane-footer">
      <div class="buttons">
        <b-button type="is-primary" :disabled="!canSubmit || submitting" @click="submitFeedback" :loading="submitting">Submit Feedback</b-button>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mood: null,
      feedback: null,
      submitting: false
    }
  },
  methods: {
    async submitFeedback() {
      if (!this.feedback) return;
      const feedbackItem = {
        mood: this.mood,
        feedback: this.feedback,
        browserMeta: {
          // eslint-disable-next-line no-restricted-globals
          screenResolution: `${screen.width}x${screen.height}`,
          windowResolution: `${window.innerWidth}x${window.innerHeight}`,
          userAgent: this.getBrowserInfo().userAgent,
          url: window.location.href
        }
      }
      this.submitting = true;
      const result = await this.$store.dispatch('submitFeedback', feedbackItem);
      this.submitting = false;
      if (result) {
        this.mood = null;
        this.feedback = null;
        this.$buefy.toast.open({
          duration: 3000,
          message: 'Thanks for submitting feedback!',
          position: 'is-bottom-right',
          type: 'is-success'
        });
        // KyAnalytics client plugin, event tracker
        this.$kya.event('system', 'submitFeedback', 'Feedback submitted', { payload: feedbackItem });
        this.close();
      }
    },
    getBrowserInfo() {
      // eslint-disable-next-line one-var, no-var
      var ua = navigator.userAgent, 
        tem, 
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE', version: (tem[1] || '') };
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return { name: 'Opera', version: tem[1] }; }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      // eslint-disable-next-line no-cond-assign
      if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
      return {
        name: M[0],
        version: M[1],
        userAgent: navigator.userAgent
      };
    }
  },
  computed: {
    canSubmit() {
      return (this.feedback);
    }
  },
  props: {
    close: Function
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/colors';

.kpt-feedback-context-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
  .kpt-feedback-icons {
    .feedback-icon {
      margin-right: 8px;
      &:hover {
        cursor: pointer;
      }
      &.kpt-smile-icon {
        &:hover {
          color: $green;
        }
      }
      &.kpt-meh-icon {
        &:hover {
          color: $yellow;
        }
      }
      &.kpt-frown-icon {
        &:hover {
          color: $red;
        }
      }
    }
  }
}
</style>
